import { render } from "./Public.vue?vue&type=template&id=8efe04c6&scoped=true"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"

import "./Public.vue?vue&type=style&index=0&id=8efe04c6&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efe04c6"]])

export default __exports__